<template>
  <section id='forgotPassword' class='section'>
    <div class="title">Change Password</div>
      <label class="label">Email</label>
      <div class="control">
        <input class="input" type="text" placeholder="Enter email" v-model='email'>
      </div>
      <p class="is-danger help">{{error.email}}</p>
    </div>
    <p class='control'>
      <button class='button is-info' :class='{"is-loading": isLoading}' @click='submitForgotPassword'>Send Reset Email</button>
    </p>
    <br>
  <div v-if='msg' class='notification is-info'>{{msg}}</div>
  </section>
</template>

<script>

export default {
  name: 'forgotPassword',
  data() {
    return {
      isLoading: false,
      isReset: false,
      error: {
        email: this.msgAlias,
      },
      email: '',
      msg: '',
    };
  },
  methods: {
    resetFields() {
      Object.assign(this.$data, this.$options.data.call(this));
      this.isReset = true;
    },
    isEmailValid() {
      if (this.$helpers.isEmail(this.email)) {
        this.error.email = '';
        return true;
      }
      this.error.email = this.msgEmail;
      return false;
    },
    submitForgotPassword() {
      if (!this.isEmailValid()) {
        return;
      }
      this.isLoading = true;
      this.$http.post('/scarf/forgotPassword', {
        email: this.email,
      })
        .then((res) => {
          this.isLoading = false;
          console.log('forgot pass:', res.data);
          // Wrong credentials. Access denied.
          this.resetFields();
          if (res.data.ok === 1) {
            this.msg = 'Check you email to reset password.';
          } else {
            this.msg = res.data.message;
          }
        });
    },
  },
  watch: {
    email(val) {
      if (this.$helpers.isEmail(val)) {
        this.error.email = '';
        return;
      }
      this.error.email = this.msgEmail;
    },
  },
  computed: {
    msgEmail() {
      if (this.isReset) {
        this.isReset = false;
        return '';
      }
      return 'Enter valid email';
    },
  },
};
</script>

<style scoped>
.button, .button:hover {
  background-color: #47a0db;
}
</style>



// WEBPACK FOOTER //
// src/components/login/ForgotPassword.vue